class SpotAddType {
  constructor() {
    this.items = document.querySelectorAll('.top-spot-list__item');
  }
  init() {
    this.attachEvent();
  }
  attachEvent() {
    for (let item of this.items) {
      let counter = item.querySelector('.top-spot-link').children.length
      if((counter === 3)) {
        item.querySelector('.top-spot-link').classList.add('is-col--3');
      } else if(counter === 2) {
        item.querySelector('.top-spot-link').classList.add('is-col--2');
      } else if(counter === 1)
      item.querySelector('.top-spot-link').classList.add('is-col--1');
    }
  }
}
const spotAddType = new SpotAddType();
spotAddType.init();


$(document).ready(function(){
  setTimeout(function(){
    $('.gm-style-pbc').addClass('hoge');
    console.log($('div[title]').length);
    $('div[title]').each(function() {
      $(this).attr('data-map','data-element-map');
    });
},3000);

});